import {
  LABOTURNOS_SUCCESS,
  LABOTURNOS_LOADING,
  LABOTURNOS_ERROR,
  LABOTURNOS_LOGOUT,
  LABOTURNOS_FLG_CAMBIARTURNO,
  LABOTURNOS_FLG_BUSCARTURNOLABO,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";

// export const wsGetVerificarLaboGrupo = (id, idPacFamiliar) => (dispatch) => {
//   dispatch({
//     type: LABOTURNOS_LOADING,
//   });

//   axiosInstance().then((respuesta) => {
//     respuesta
//       .get(
//         `/laboratorio/verificarOS/${id}/${!idPacFamiliar ? "" : idPacFamiliar}`
//       )
//       .then((res) => {
//         dispatch({
//           type: LABOTURNOS_SUCCESS,
//           payload: res.data,
//         });
//       })
//       .catch((err) => {
//         let error = {
//           detail: err.response
//             ? err.response.data
//             : "Error al contactar el server.",
//         };

//         dispatch({
//           type: LABOTURNOS_ERROR,
//           payload: error,
//         });
//       });
//   });
// };

export const wsGetVerificarLaboGrupo =
  (id, idPacFamiliar, nextStep) => (dispatch) => {
    dispatch({ type: LABOTURNOS_LOADING });
    axiosInstance().then((respuesta) => {
      respuesta
        .get(
          `/laboratorio/verificarOS/${id}/${
            !idPacFamiliar ? "" : idPacFamiliar
          }`
        )
        .then((resp) => {
          dispatch({
            type: LABOTURNOS_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: LABOTURNOS_ERROR, payload: err.data });
          if (nextStep) nextStep(false, err.response.data);
        });
    });
  };

// export const wsGetLaboTurnos =
//   (fechaDesde, idCentro, idRecepcion, idGrupoEstudio, idPacFamiliar) =>
//   (dispatch) => {
//     dispatch({
//       type: LABOTURNOS_LOADING,
//     });

//     axiosInstance().then((respuesta) => {
//       respuesta
//         .get(
//           `/laboratorio/turnosDisponiblesNew/${fechaDesde}/${idCentro}/${idRecepcion}/${idGrupoEstudio}/${
//             !idPacFamiliar ? "" : idPacFamiliar
//           }`
//         )
//         .then((res) => {
//           dispatch({
//             type: LABOTURNOS_SUCCESS,
//             payload: res.data,
//           });
//         })
//         .catch((err) => {
//           let error = {
//             detail: err.response
//               ? err.response.data
//               : "Error al contactar el server.",
//           };

//           dispatch({
//             type: LABOTURNOS_ERROR,
//             payload: error,
//           });
//         });
//     });
//   };

export const wsGetLaboTurnos = (fechaDesde, idCentro, idRecepcion, idGrupoEstudio, idPacFamiliar, nextStep) => (dispatch) => {
    dispatch({ type: LABOTURNOS_LOADING });
    axiosInstance().then((respuesta) => {
      respuesta
        .get(
          `/laboratorio/turnosDisponiblesNew/${fechaDesde}/${idCentro}/${idRecepcion}/${idGrupoEstudio}/${
            !idPacFamiliar ? "" : idPacFamiliar
          }`
        )
        .then((resp) => {
          dispatch({
            type: LABOTURNOS_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: LABOTURNOS_ERROR, payload: err.data });
          if (nextStep) nextStep(false, err.response.data);
        });
    });
  };

export const wsPostTomarTurnoLaboratorio =
  (requestBody, idPariente) => (dispatch) => {
    dispatch({
      type: LABOTURNOS_LOADING,
    });

    axiosInstance().then((respuesta) => {
      respuesta
        .post(
          `/laboratorio/AltaProtocolo/${!idPariente ? "" : idPariente}`,
          requestBody
        )
        .then((res) => {
          dispatch({
            type: LABOTURNOS_SUCCESS,
            payload: res.data,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };

          dispatch({
            type: LABOTURNOS_ERROR,
            payload: error,
          });
        });
    });
  };

export const wsPutCambiarTurnoLaboratorio =
  (idTurnoNuevo, idProtocolo, idPacFamiliar) => (dispatch) => {
    dispatch({
      type: LABOTURNOS_LOADING,
    });

    axiosInstance().then((respuesta) => {
      respuesta
        .put(
          `/laboratorio/cambiarTurno/${idTurnoNuevo}/${idProtocolo}/${idPacFamiliar}`
        )
        .then((res) => {
          dispatch({
            type: LABOTURNOS_SUCCESS,
            payload: res.data,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };

          dispatch({
            type: LABOTURNOS_ERROR,
            payload: error,
          });
        });
    });
  };

export const setFlgCambiarTurno = (flgCambiarTurno) => (dispatch) => {
  dispatch({ type: LABOTURNOS_FLG_CAMBIARTURNO, payload: flgCambiarTurno });
};

export const setBuscarTurnoLabo = (flgBuscarTurno) => (dispatch) => {
  dispatch({ type: LABOTURNOS_FLG_BUSCARTURNOLABO, payload: flgBuscarTurno });
};

export const logoutLaboTurnos = () => (dispatch) => {
  dispatch({ type: LABOTURNOS_LOGOUT });
};
